module.exports = __webpack_public_path__ + "static/media/agreements.e5918443.png";